(function() {
  if (typeof window.G === 'undefined') { window.G = {}; }

  // Struttura Gerarchica Completa: Regione > Macro-Area > [ [Denominazione/Luogo, ...sinonimi], ... ]
  window.G.ENOGRAPHIC_PACK = {
    // =========================================================================
    // NORD ITALIA
    // =========================================================================
    "Valle d'Aosta": {
      "Valdigne": [ ["Valle d'Aosta Blanc de Morgex et de La Salle", "blanc de morgex", "morgex", "la salle"] ],
      "Valle Centrale": [ ["Valle d'Aosta Torrette", "torrette"], ["Valle d'Aosta Nus", "nus malvoisie", "nus rouge", "nus"], ["Valle d'Aosta Chambave", "chambave muscat", "chambave"] ],
      "Bassa Valle": [ ["Valle d'Aosta Donnas", "donnas"], ["Valle d'Aosta Arnad-Montjovet", "arnad-montjovet", "arnad", "montjovet"] ],
      "Altre Zone": [ ["Valle d'Aosta Enfer d'Arvier", "enfer d'arvier", "arvier"] ]
    },
    "Piemonte": {
      "Langhe & Barolo Zone": [
        ["Barolo", "barolo docg", "bussia", "cannubi", "ginestra", "monvigliero", "barolo riserva", "serralunga d'alba", "la morra", "monforte d'alba", "castiglione falletto", "verduno", "novello", "grinzane cavour", "barolo (comune)", "perno", "giachini", "bricco manzoni", "bricco luciani", "annunziata", "plicotti", "meriame", "lazzarito", "fossati", "liste", "le teorie", "briccobergera", "paiagallo", "san lorenzo"],
        ["Barbaresco", "barbaresco docg", "barbaresco riserva", "neive", "treiso", "nervo", "fratin", "meruzzano", "gaia principe", "Neive"],
        ["Langhe", "langhe doc", "langhe bianco", "langhe rosso", "langhe nebbiolo", "langhe arneis", "langhe riesling", "langhe rosato", "alba", "tre stelle"],
        ["Dogliani", "dogliani docg"],
        ["Verduno Pelaverga", "pelaverga", "verduno doc"],
        ["Alba","Nebbiolo d'Alba", "nebbiolo d'alba doc"],
        ["Barbera d'Alba", "barbera d'alba doc", "barbera d'alba superiore"],
        ["Dolcetto d'Alba", "dolcetto d'alba"]
      ],
      "Roero": [ ["Roero", "roero docg", "roero arneis", "roero riserva", "canale", "montà d'alba", "vezza d'alba"] ],
      "Monferrato & Asti": [
        ["Nizza", "nizza docg", "nizza monferrato"],
        ["Barbera d'Asti", "barbera d'asti docg"],
        ["Asti", "asti spumante", "asti secco", "asti dolce", "asti docg"],
        ["Moscato d'Asti", "moscato d'asti docg", "canelli"],
        ["Monferrato", "monferrato doc"],
        ["Dolcetto d'Asti", "dolcetto d'asti doc"],
        ["Alta Langa", "alta langa docg", "alta langa riserva"],
        ["Ruchè di Castagnole Monferrato", "ruchè"],
        ["Grignolino d'Asti", "grignolino"],
        ["Costigliole d'Asti"], ["Mango"]
      ],
      "Gavi": [ ["Gavi", "gavi del comune di gavi", "gavi docg"] ],
      "Alto Piemonte": [
        ["Gattinara", "gattinara docg", "gattinara riserva"],
        ["Ghemme", "ghemme docg"],
        ["Lessona"], ["Boca"], ["Bramaterra"], ["Carema"], ["Sizzano"], ["Fara"],
        ["Colline Novaresi", "colline novaresi doc"],
        ["Vercelli"]
      ],
      "Colli Tortonesi": [ ["Colli Tortonesi", "derthona", "timorasso", "tortona"] ],
      "Other Piedmont": [ ["Loazzolo", "loazzolo doc"], ["Castellinaldo d'Alba", "castellinaldo"], ["Piemonte DOC", "piemonte barbera", "piemonte chardonnay"], ["Roddì"]]
    },
    "Lombardia": {
      "Valtellina": [ ["Sforzato di Valtellina", "sfursat"], ["Valtellina Superiore", "valtellina superiore docg", "inferno", "sassella", "grumello", "valgella", "maroggia"] ],
      "Franciacorta": [ ["Franciacorta", "franciacorta docg", "franciacorta satèn", "satèn", "capriolo"] ],
      "Oltrepò Pavese": [ ["Oltrepò Pavese Metodo Classico", "oltrepo pavese metodo classico"], ["Pinot Nero dell'Oltrepò Pavese", "pinot nero oltrepo"], ["Santa Giuletta"], ["Calvignano"] ],
      "Lugana & Garda": [ ["Lugana", "lugana doc"], ["Valtènesi", "valtenesi", "riviera del garda classico"] ],
      "Other Lombardy": [ ["Valcalepio"], ["Moscato di Scanzo", "scanzo"] ]
    },
    "Trentino-Alto Adige": {
      "Trento DOC": [ ["Trento DOC", "trento", "trentodoc", "trento riserva"] ],
      "Alto Adige / Südtirol": [ ["Alto Adige", "südtirol", "alto adige doc"], ["Santa Maddalena", "st. magdalener"], ["Lago di Caldaro", "kalterersee", "caldaro"], ["Valle Isarco", "eisacktaler"], ["Val Venosta", "vinschgau"], ["Merano"], ["Meltina"], ["Oltradige", "überetsch"], ["Bassa Atesina", "unterland"] ],
      "Trentino": [ ["Teroldego Rotaliano", "teroldego", "piana rotaliana"], ["Trentino DOC", "marzemino", "valdadige", "sorni", "isera", "ziresi"], ["San Michele all'Adige"], ["Cavalese"], ["Lavis"] ],
      "Dolomiti": [ ["Vigneti delle Dolomiti IGT", "dolomiti igt", "vallagarina"] ]
    },
    "Veneto": {
      "Valpolicella": [ ["Amarone della Valpolicella", "amarone", "amarone classico", "amarone riserva"], ["Valpolicella Ripasso", "ripasso", "ripasso della valpolicella"], ["Recioto della Valpolicella", "recioto"], ["Valpolicella", "valpolicella classica", "valpolicella superiore", "valpantena", "marano di valpolicella"] ],
      "Soave": [ ["Soave Classico", "soave"], ["Soave Superiore", "soave superiore docg"], ["Recioto di Soave"] ],
      "Prosecco": [ ["Conegliano Valdobbiadene Prosecco Superiore", "prosecco superiore", "valdobbiadene", "conegliano", "cartizze", "rive"], ["Asolo Prosecco", "asolo docg", "montello e collio asolani", "asolo"], ["Prosecco DOC", "prosecco treviso"] ],
      "Garda & Verona": [ ["Lugana", "lugana doc"], ["Custoza", "bianco di custoza"], ["Bardolino", "bardolino chiaretto", "bardolino la rocca", "bardolino montebaldo", "bardolino sommacampagna"], ["Caprino Veronese"], ["Sommacampagna"] ],
      "Colli Berici & Euganei": [ ["Colli Berici", "tai rosso"], ["Colli Euganei", "fior d'arancio"], ["Montecchio Maggiore"] ],
      "Other Veneto": [ ["Breganze", "torcolato"], ["Lessini Durello", "durello"], ["Lison", "lison docg"], ["Piave", "piave doc"], ["Gambellara"], ["Veneto IGT", "verona igt", "trevenezie igt", "verona", "vicenza"] ]
    },
    "Friuli-Venezia Giulia": {
      "Collio & Colli Orientali": [ ["Collio", "collio goriziano", "brda", "cormons"], ["Friuli Colli Orientali", "colli orientali", "rosazzo", "cialla", "schioppettino di prepotto", "refosco di faedis", "pignolo di rosazzo", "ribolla gialla di rosazzo", "capriva del friuli"] ],
      "Grave, Isonzo & Carso": [ ["Friuli Grave", "grave"], ["Friuli Isonzo", "isonzo"], ["Carso", "kras"] ],
      "Other Friuli": [ ["Ramandolo"], ["Venezia Giulia IGT", "venezia giulia"] ]
    },
    "Liguria": {
      "Riviera di Ponente": [ ["Riviera Ligure di Ponente", "pigato", "vermentino ligure", "finalese", "albenganese", "quiliano"], ["Rossese di Dolceacqua", "dolceacqua", "taggia"] ],
      "Riviera di Levante": [ ["Cinque Terre", "cinque terre sciacchetrà", "sciacchetrà", "costa de sera", "costa de campu", "costa da posa"], ["Colli di Luni", "vermentino colli di luni", "castelnuovo magra", "la spezia"] ]
    },
    "Emilia-Romagna": {
      "Emilia": [ ["Lambrusco di Sorbara", "sorbara"], ["Lambrusco Grasparossa di Castelvetro", "grasparossa", "castelvetro"], ["Lambrusco Salamino di Santa Croce", "lambrusco salamino"], ["Colli Piacentini", "gutturnio", "ortrugo", "piacenza"] ],
      "Romagna": [ ["Romagna Sangiovese", "sangiovese di romagna", "romagna sangiovese riserva", "predappio", "brisighella", "bertinoro", "marzeno", "modigliana", "oriolo", "san clemente", "verucchio"], ["Albana di Romagna", "albana"], ["Colli di Faenza", "colli bolognesi"], ["Dozza", "odozza"] ]
    },
    // =========================================================================
    // CENTRO ITALIA
    // =========================================================================
    "Toscana": {
      "Montalcino": [ ["Brunello di Montalcino", "brunello"], ["Rosso di Montalcino"], ["Moscadello di Montalcino"], ["Sant'Antimo"], ["Sant'Angelo in Colle"], ["Castelnuovo dell'Abate"] ],
      "Montepulciano": [ ["Vino Nobile di Montepulciano", "vino nobile"], ["Rosso di Montepulciano"], ["Cervognano"] ],
      "Chianti Classico": [ ["Chianti Classico", "gallo nero", "chianti classico riserva", "chianti classico gran selezione", "castellina", "castelnuovo berardenga", "gaiole", "greve", "panzano", "radda", "san casciano", "vagliagli"] ],
      "Other Chianti Zones": [ ["Chianti", "chianti docg", "chianti colli senesi", "chianti rufina", "chianti colli fiorentini", "chianti colli aretini", "chianti colline pisane", "chianti montalbano", "chianti montespertoli"] ],
      "Maremma & Coast": [ ["Bolgheri", "bolgheri superiore", "bolgheri sassicaia", "sassicaia", "castagneto carducci"], ["Morellino di Scansano", "morellino", "scansano"], ["Val di Cornia Rosso", "val di cornia"], ["Monteverdi Marittimo"], ["Castiglione della Pescaia"] ],
      "Other Tuscany": [ ["Vernaccia di San Gimignano", "san gimignano"], ["Carmignano"], ["Cortona", "cortona doc"], ["Val d'Orcia", "valdorcia"], ["Toscana IGT", "supertuscan", "supertoscano"], ["Scandicci"], ["Reggello"] ]
    },
    "Umbria": {
      "Montefalco & Todi": [ ["Montefalco Sagrantino", "sagrantino di montefalco", "sagrantino"], ["Montefalco Rosso"], ["Grechetto di Todi", "grechetto", "todi"], ["Bevagna"], ["Gualdo Cattaneo"] ],
      "Orvieto & Torgiano": [ ["Orvieto Classico", "orvieto"], ["Torgiano Rosso Riserva", "torgiano"] ],
      "Other Umbria": [ ["Colli del Trasimeno", "trasimeno"], ["Spoleto"], ["Umbria IGT"] ]
    },
    "Marche": {
      "Verdicchio Zones": [ ["Verdicchio dei Castelli di Jesi", "verdicchio di jesi"], ["Verdicchio di Matelica", "verdicchio di matelica"] ],
      "Piceno": [ ["Rosso Piceno", "rosso piceno superiore"], ["Offida", "offida docg", "offida pecorino", "offida passerina"], ["Comunanza"] ],
      "Conero": [ ["Rosso Conero", "conero riserva"] ],
      "Other Marche": [ ["Lacrima di Morro d'Alba", "lacrima"], ["Marche IGT"] ]
    },
    "Lazio": {
      "Castelli Romani": [ ["Frascati Superiore", "frascati"], ["Castelli Romani"] ],
      "Cesanese": [ ["Cesanese del Piglio", "piglio"], ["Cesanese di Olevano Romano", "olevano romano"] ],
      "Other Lazio": [ ["Est! Est!! Est!!! di Montefiascone", "est est est"], ["Circeo"] ]
    },
    "Abruzzo": {
      "Montepulciano Zones": [ ["Montepulciano d'Abruzzo Colline Teramane", "colline teramane"], ["Montepulciano d'Abruzzo", "montepulciano abruzzese"], ["Terre dei Vestini"], ["Terre dei Peligni"], ["Teate"] ],
      "Other Abruzzo": [ ["Trebbiano d'Abruzzo"], ["Cerasuolo d'Abruzzo"], ["Alto Tirino"], ["Abruzzo DOC"], ["San Martino sulla Marrucina"], ["San Salvo"], ["Rocca San Giovanni"] ]
    },
    "Molise": {
      "Molise": [ ["Tintilia del Molise", "tintilia"], ["Pentro di Isernia", "pentro", "isernia"], ["Biferno"] ]
    },
    // =========================================================================
    // SUD ITALIA E ISOLE
    // =========================================================================
    "Campania": {
      "Irpinia": [ ["Taurasi", "taurasi riserva"], ["Fiano di Avellino", "fiano"], ["Greco di Tufo", "greco"], ["Aglianico Irpinia", "irpinia aglianico"], ["Grottaminarda"], ["Pietradefusi"] ],
      "Sannio & Caserta": [ ["Aglianico del Taburno", "taburno"], ["Falanghina del Sannio", "falanghina"], ["Falerno del Massico", "falerno"], ["Asprinio di Aversa", "aversa"], ["Sannio", "sannio solopaca", "sannio guardiolo"], ["Foglianise"] ],
      "Costiera & Isole": [ ["Costa d'Amalfi", "furore", "ravello", "tramonti"], ["Ischia", "ischia bianco"] ],
      "Other Campania": [ ["Campi Flegrei", "falanghina campi flegrei"], ["Cilento"] ]
    },
    "Puglia": {
      "Salento": [ ["Primitivo di Manduria", "primitivo di manduria dolce naturale", "manduria"], ["Salice Salentino", "salice salentino riserva"], ["Negroamaro", "brindisi rosso", "copertino", "leverano", "nardo"], ["Salento IGT"] ],
      "Puglia Centrale": [ ["Castel del Monte", "castel del monte nero di troia riserva"], ["Gioia del Colle", "primitivo di gioia del colle"], ["Locorotondo"], ["Martina Franca"], ["Orsara di Puglia"] ],
      "Puglia IGT & Altro": [ ["Puglia IGT"], ["San Severo"] ]
    },
    "Basilicata": {
      "Vulture": [ ["Aglianico del Vulture Superiore", "aglianico del vulture", "vulture"], ["Venosa"] ],
      "Matera": [ ["Matera DOC", "matera"] ]
    },
    "Calabria": {
      "Cirò & Greco": [ ["Cirò", "cirò rosso", "cirò bianco"], ["Greco di Bianco", "greco di bianco"], ["Melissa"] ],
      "Terre di Cosenza": [ ["Terre di Cosenza", "cosenza", "donnici", "pollino", "san vito di luzzi"] ],
      "Other Calabria": [ ["Lamezia"], ["Bivongi"], ["Scavigna"], ["Savuto"] ]
    },
    "Sicilia": {
      "Etna": [ ["Etna Rosso", "etna rosso doc", "etna nord", "randazzo", "passopisciaro"], ["Etna Bianco", "etna bianco doc", "etna sud-est", "milo"], ["Etna Rosato"] ],
      "Sud-Est Sicilia": [ ["Cerasuolo di Vittoria", "cerasuolo", "vittoria"], ["Noto", "nero d'avola di noto", "val di noto"], ["Eloro", "eloro pachino"] ],
      "Sicilia Occidentale": [ ["Marsala", "marsala vergine"], ["Faro", "faro doc"], ["Sicilia DOC", "sicilia doc"], ["Menfi"], ["Alcamo"], ["Trapani"], ["Erice"] ],
      "Isole Minori": [ ["Pantelleria", "passito di pantelleria", "moscato di pantelleria"] ]
    },
    "Sardegna": {
      "Nord Sardegna": [ ["Vermentino di Gallura", "gallura", "monti"], ["Vermentino di Sardegna"], ["Alghero"] ],
      "Sud Sardegna": [ ["Carignano del Sulcis", "sulcis"], ["Cannonau di Sardegna", "cannonau", "capo ferrato", "jerzu", "oliena", "nepente"], ["Campidano di Terralba", "terralba"], ["Dolianova"], ["Muravera"] ],
      "Other Sardinia": [ ["Vernaccia di Oristano", "oristano"], ["Malvasia di Bosa", "bosa"], ["Monica di Sardegna"], ["Mandrolisai"] ]
    }
  };

  // Funzione di utilità per creare una lista piatta di tutti i termini per il matching
  const allTerms = [];
  for (const region in window.G.ENOGRAPHIC_PACK) {
    for (const macroArea in window.G.ENOGRAPHIC_PACK[region]) {
        window.G.ENOGRAPHIC_PACK[region][macroArea].forEach(cluster => {
            allTerms.push(...cluster);
        });
    }
  }
  window.G.allTermsForMatching = Array.from(new Set(allTerms.filter(Boolean).map(s => s.toLowerCase().trim())));

})();
(function () {
  if (typeof window === "undefined") return;
  if (!window.G || !window.G.ENOGRAPHIC_PACK) return;

  // ---------- utils ----------
  const norm = s => (s || "")
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[\u2019\u2018’']/g, "")
    .replace(/[^a-z0-9 ]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  // Heuristic classifier: infer kind (kept non-destructive; we don't change your data, just label it)
  function classifyKind(term) {
    const t = norm(term);
    if (/\bdocg\b/.test(t)) return "docg";
    if (/\bdoc\b/.test(t)) return "doc";
    if (/\bigt\b/.test(t)) return "igt";
    // DOC-ish markers that often accompany appellations
    if (/\bclassico|superiore|riserva|passito\b/.test(t)) return "doc_like";
    // Commune/subzone guesses (weak, but helpful for geo splits)
    if (/\b(comune|castel|castello|monte|val|san)\b/.test(t)) return "place";
    return "unknown";
  }

  // Tiny typo/variant normalizer for frequent cases you have in data
  function fixTypos(t) {
    t = t.replace(/\bsuedtirol\b/g, "sudtirol");
    t = t.replace(/\bsuedtirol\b/g, "sudtirol");
    t = t.replace(/\bvald o?rcia\b/g, "val d orcia");
    t = t.replace(/\brodd[iì]\b/g, "roddi");
    return t;
  }

  // ---------- build enriched structures ----------
  const aliasIndex = new Map(); // alias -> [{region, macro, canon, kind}]
  const canonIndex = new Map(); // canon -> {region, macro, kind, aliases[]}
  const geoOnly = new Set();    // places only
  const appsOnly = new Set();   // DOC/DOCG/IGT only
  const warnings = [];

  function addAlias(alias, payload) {
    const a = fixTypos(norm(alias));
    if (!a) return;
    const arr = aliasIndex.get(a) || [];
    // avoid exact dup payloads
    if (!arr.some(x => x.region === payload.region && x.macro === payload.macro && x.canon === payload.canon)) {
      arr.push(payload);
      aliasIndex.set(a, arr);
    }
  }

  function pushSetByKind(term, kind) {
    const t = fixTypos(norm(term));
    if (!t) return;
    if (kind === "docg" || kind === "doc" || kind === "igt" || kind === "doc_like") {
      appsOnly.add(t);
    } else {
      geoOnly.add(t);
    }
  }

  const pack = window.G.ENOGRAPHIC_PACK;

  for (const region in pack) {
    const macros = pack[region] || {};
    for (const macro in macros) {
      const clusters = macros[macro] || [];
      clusters.forEach(cluster => {
        if (!cluster || !cluster.length) {
          warnings.push({ type: "empty-cluster", region, macro });
          return;
        }
        const canon = cluster[0];
        const aliases = cluster.slice(1);

        // classify by strongest signal among canon+aliases
        const kinds = [canon, ...aliases].map(classifyKind);
        const kind = kinds.includes("docg") ? "docg"
                    : kinds.includes("doc") ? "doc"
                    : kinds.includes("igt") ? "igt"
                    : kinds.includes("doc_like") ? "doc_like"
                    : "place";

        // canon index
        const canonKey = norm(canon);
        if (canonIndex.has(canonKey)) {
          const prev = canonIndex.get(canonKey);
          // Same canon name in multiple macro/region is ok, but warn (helps QA)
          if (prev.region !== region || prev.macro !== macro) {
            warnings.push({ type: "canon-duplicate", canon, a: { region: prev.region, macro: prev.macro }, b: { region, macro } });
          }
        } else {
          canonIndex.set(canonKey, { region, macro, kind, aliases: cluster.slice(1),
              canon   : canon     // 👈 add this

           });
        }

        // alias index (canon counts as an alias too)
        [canon, ...aliases].forEach(a => addAlias(a, { region, macro, canon, kind }));

        // update curated flat sets
        [canon, ...aliases].forEach(a => pushSetByKind(a, kind));
      });
    }
  }

  // Expose enriched structures
  window.G.GEOPACK = {
    aliasIndex,  // Map<string, Array<{region, macro, canon, kind}>>
    canonIndex,  // Map<string, {region, macro, kind, aliases[]}>
    subregionsGeoOnly: Array.from(geoOnly),
    appellationsAll: Array.from(appsOnly),
    warnings
  };

  // Keep your original export for compatibility
  // Also rebuild your allTermsForMatching with dedupe on top of the curated sets (apps + geo)
  window.G.allTermsForMatching = Array.from(new Set([
    ...window.G.GEOPACK.subregionsGeoOnly,
    ...window.G.GEOPACK.appellationsAll
  ]));

  if (warnings.length) {
    console.info("[Geopack QA] warnings:", warnings);
  } else {
    console.info("[Geopack] indexes ready. Terms:", window.G.allTermsForMatching.length);
  }
})();
